import api from "../index"
import { apiTags } from "../tags"

const rolesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRoles: build.query({
      query: (params) => ({
        url: `/roles`,
        method: "GET",
        params,
      }),
    }),
    getAllRoles: build.query({
      query: (params) => ({
        url: `/roles/all`,
        method: "GET",
        params,
      }),
    }),
    getRole: build.query({
      query: ({ id }) => ({
        url: `/roles/${id}`,
        method: "GET",
      }),
    }),
    getRolePermissions: build.query({
      query: () => ({
        url: `/roles/all/permissions`,
        method: "GET",
      }),
    }),
    createRole: build.mutation({
      query: (body) => ({
        url: `/roles`,
        method: "POST",
        body,
      }),
    }),
    updateRole: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/roles/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    deleteRoles: build.mutation({
      query: ({ id }) => ({
        url: `/roles/${id}`,
        method: "DELETE",
      }),
    }),
  }),
})

export const {
  useLazyGetRolesQuery,
  useGetRolesQuery,
  useGetAllRolesQuery,
  useLazyGetRolePermissionsQuery,
  useLazyGetRoleQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRolesMutation,
} = rolesApi
